<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" @click.prevent="back">返回</a>
        <h1>学习成绩</h1>
        <a class="pull-right icon-right icon-setup text-hide" @click.prevent="popupVisibleScoreList = true" v-if="studentId == 0">发布</a>
      </div>
      <div class="liner"></div>
    </div>


    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page bg-white" style="padding-bottom:0;" v-infinite-scroll="loadBottom"
    infinite-scroll-disabled="isGetting"
    infinite-scroll-distance="150">
      <div class="text-center mid-align vw100" v-if="studentId != 0 && scoreList.length == 0 && isGetting == false"><p class="padding-15">还没有添加该学生的学习成绩哦！</p></div>
      <div class="text-center mid-align vw100" v-if="studentId == 0 && scoreList.length == 0 && isGetting == false"><p class="padding-15">还没有添加过学生成绩哦！</p></div>
      <div class="dynamic">
        <div v-for="(score, index) in scoreList">
          <div class="padding-15 clearfix">
            <div class="pull-left left-part"><div class="img-wrap small"><img :src="score.field2 ? baseAcessPath + score.field2 : img_default" width="100%" /></div></div>
            <div class="right-part">
              <span class="font-16">{{score.studentName}}</span>
              <div class="score gray">
                <cite>{{score.subject}}</cite>-
                <span>{{score.testName}}</span>-
                <strong class="red">{{score.score}}</strong>
                <div class="liner"></div>
              </div>

              <p v-if="score.content">{{score.content}}</p>
              <ul class="block clearfix imgs">
                <li class="col-xs-4" v-for="(img, index) in score.picList">
                  <div class="t-r-5">
                    <div class="out-wrap">
                      <span @click="showImgList(score.picList, index)">
                        <!-- <img :data-original="score.baseAcessPath + img.thumbAddress" v-if="img.thumbAddress"/>
                        <img :src="img.baseAcessPath + img.thumbAddress" v-else/> -->
                        <img class="mid-align" :src="score.baseAcessPath + img.thumbAddress" v-if="img.thumbAddress"/>
                        <img class="mid-align" :src="img.baseAcessPath + img.thumbAddress" v-else/>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="clearfix">
                <cite class="gray pull-left font-12">{{score.publishDate | dateDiff}}</cite>
                <span class="pull-left margin-x-15 font-12" v-if="score.teacherId == teacherId" @click="delScoreId = score.scoreId, delScoreIndex = index, isHideDelScore = false">删除</span>
                <span class="pull-right  font-12">{{score.teacherName}}老师</span>
              </div>
            </div>
          </div>
          <div class="liner"></div>
        </div>
      </div>
    </div>
    </mt-loadmore>

    <mt-popup
      v-model="popupVisibleScoreList"
      position="bottom">
      <div class="shall text-center">
      <div class="clearfix margin-15 font-12">
        <div class="col-xs-6"><router-link class="icon-add icon gray" :to="{'path': '/score/publish'}">新增一条</router-link></div>
        <div class="col-xs-6"><a class="icon-find icon gray" @click.prevent="isHideSelectStudent = false, popupVisibleScoreList = false">查看TA的成绩</a></div>
      </div>
      <p class="gray margin-15 padding-15 font-12">持续记录孩子的学习成绩，方便您了解孩子的学习成绩变化；学习成绩只有老师和孩子关联的家长才能看到，其他家长看不到。</p>
      <ul class="list-group-item tinny" style="margin:0">
        <li class="list-group">
          <div class="liner"></div>
          <span class="group-txt" @click="popupVisibleScoreList = false">取消</span>
        </li>
      </ul>
    </div>
    </mt-popup>

    <!-- 删除动态 -->
    <div class="maskdiv" v-show="!isHideDelScore" @click="isHideDelScore = true">
      <div class="popover" @click.stop>
        <div class="pop-wrap text-center">
          <p class="margin-15">您确定要删除动态吗？</p>
          <div class="liner margin-15"></div>
          <div class="clearfix">
              <div class="col-xs-6 blue"><a class="blue  block" style="border-right:1px solid #ddd;" @click.prevent="deleteScore()">确定</a></div>
              <div class="col-xs-6 blue"><a class="blue" @click.prevent="isHideDelScore = true">取消</a></div>
            </div>
        </div>
      </div>
    </div>

    <div class="maskdiv" @click="isShowImgs = false" v-if="isShowImgs" style="background:rgba(0,0,0,1)">
      <div class="imgs-box" >
        <div class="swiper-container" >
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in imageList" style="height:100vh">
              <img :data-src="baseAcessPath + item.imageAddress" class="swiper-lazy hide bigger-pic" :thumbImg="baseAcessPath + item.thumbAddress"/>
              <!-- <div class="swiper-lazy-preloader" style="width:100%"><img :src="item.baseAcessPath + item.thumbAddress" style="position:fixed"></div> -->
              <!-- <div class="swiper-lazy-preloader swiper-lazy-preloader-white" style="position:fixed"></div> -->
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>

    <!-- 选择学生 -->
    <dialogStudents :isHideSelectStudent="isHideSelectStudent" :studentFirstCharList="studentFirstCharList" v-on:close="closeDialogStudents" v-on:selected="selectedStudent"></dialogStudents>
  </div>

</template>

<script>
import { Toast } from 'mint-ui'
import { service } from '../../service'
import { mapGetters, mapMutations } from 'vuex'
// component
import dialogStudents from '../../components/student/dialogStudents'

export default {
  computed: mapGetters({
    studentFirstCharList: 'getStudentsByFirstChar'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      dynamicTypeId: 0,
      offset: 0,
      curcheId: 0,
      teacherId: 0,
      isGetting: true, // 是否正在获取数据中
      isOver: false, // 是否是没有数据获取了
      sel_score_para: service.setPara('selScore'),
      del_score_para: service.setPara('delScore'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      scoreList: [],
      // 删除学生成绩
      isHideDelScore: true,
      delScoreId: -1,
      delScoreIndex: -1,
      isShowImgs: false,
      imageList: [],
      baseAcessPath: '',
      scoreNew: {},
      isUploadOver: true,
      localStorage_refreshDate: 0,
      scrollTop: 0,
      mySwiper: {},
      studentId: 0,
      studentList: [],
      popupVisibleScoreList: false,
      isHideSelectStudent: true
    }
  },
  components: {
    dialogStudents
  },
  mounted: function () {
    var scoreNewTemp = window.localStorage['score_new']
    scoreNewTemp = scoreNewTemp ? JSON.parse(scoreNewTemp) : false
      // dynamicNew = dynamicNew ? unescape(dynamicNew) : false
    this.isUploadOver = !scoreNewTemp || scoreNewTemp.isUploadOver || (new Date().getTime() - scoreNewTemp.publishDate) > 60 * 1000 || false

    if (!this.isUploadOver) {
      this.scoreNew = scoreNewTemp
    }
    this.studentId = this.$route.params.studentId
    // 隐藏弹出框
    var that = this

    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId
    this.baseAcessPath = this.cookie_login_data.baseAcessPath
    this.studentList.push(this.studentId)

    let obj = window.localStorage['scoreList']
    let flag = true
    if (obj && this.studentId == 0) {
      obj = JSON.parse(obj)
      if ((new Date().getTime() - obj.refreshDate) < 300 * 1000 || !this.isUploadOver) { // 5分钟刷一下
        if (!this.isUploadOver) {
          obj.scrollTop = 0
          this.scoreList.push(this.scoreNew)
          let item = {}
          item.isUploadOver = true
          window.localStorage['score_new'] = JSON.stringify(item)
        }
        this.scoreList = this.scoreList.concat(obj.scoreList)
        this.sel_score_para = obj.sel_score_para
        this.isOver = obj.isOver
        this.localStorage_refreshDate = obj.refreshDate
        flag = false
        that.$nextTick(function () {
          that.isGetting = false
          // $('.hotactives img').lazyload()
          document.body.scrollTop = obj.scrollTop
        })
      }
    }
    if (flag) {
      this.sel_score_para.offset = this.offset
      this.sel_score_para.curcheId = this.curcheId
      this.sel_score_para.teacherId = this.teacherId
      window.localStorage.removeItem('scoreList')
      this.selScore()
    }

    this.get_new_student_list_para.curcheId = this.cookie_login_data.curcheId
    this.get_new_student_list_para.sfzt = '在托'
    this.$store.dispatch('receiveStudents', this.get_new_student_list_para)
  },
  methods: {
    ...mapMutations([
      'receiveStudents'
    ]),
    loadTop (id) {
      this.isOver = false
      this.sel_score_para.offset = 0
      this.scoreList = []
      this.selScore()
      this.$refs.loadmore.onTopLoaded(id)
    },
    loadBottom () {
      if (this.isOver || this.isGetting) {
        return
      }
      this.offset++
      this.sel_score_para.offset = this.offset
      this.sel_score_para.refreshDate = this.refreshDate
      this.selScore()
    },
    // isScrollBottom: function () {
    //   var that = this
    //   $(window).bind('scroll', function () {
    //     that.scrollTop = document.body.scrollTop
    //     if ($(document).scrollTop() + $(window).height() > $(document).height() - 220 && !that.isGetting && !that.isOver) {
    //       that.offset++
    //       that.sel_score_para.offset = that.offset
    //       that.sel_score_para.refreshDate = that.refreshDate
    //       that.selScore()
    //     }
    //   })
    // },
    selScore: function () { // 获取动态列表
      this.isGetting = true

      let that = this
      if (this.studentId != 0) {
        this.sel_score_para.studentList = this.studentList
      }
      let obj = {context: this, para: this.sel_score_para, successFun: (response) => {
        if (response.data.returnList.length == 0) {
          that.isOver = true
        } else {
          that.baseAcessPath = response.data.baseAcessPath
          that.refreshDate = response.data.refreshDate
          var list = response.data.returnList

          that.scoreList = that.scoreList.concat(list)
          that.$nextTick(function () {
            // $('.dynamic img').lazyload()
            that.isGetting = false
          })
        }
      }}
      service.request(obj)
    },
    deleteScore: function () { // 删除学生成绩
      this.del_score_para.scoreId = this.delScoreId
      this.del_score_para.curcheId = this.curcheId
      this.del_score_para.teacherId = this.teacherId

      let that = this
      let obj = {context: this, para: this.del_score_para, successFun: (response) => {
        Toast('删除成功')
        that.isHideDelScore = true
        that.scoreList.splice(that.delScoreIndex, 1)
      }}
      service.request(obj)
    },
    showImgList: function (imgs, index) {
      var that = this
      if (this.mySwiper.destroy) {
        this.mySwiper.destroy(false, true)
      }
      this.isShowImgs = true
      this.imageList = imgs
      this.$nextTick(function () {
        that.mySwiper = new Swiper('.swiper-container', {
          // loop: true,
          // 如果需要分页器
          pagination: '.swiper-pagination',
          autoplayDisableOnInteraction: false,
          lazyLoading: true,
          autoHeight: true,
          initialSlide: index,
          onLazyImageLoad: function (swiper, slide, image) {
            $(image).before('<img class="swiper-lazy swiper-lazy-loaded " src="' + $(image).attr('thumbimg') + '">')
            $(image).before('<div class="swiper-lazy-preloader swiper-lazy-preloader-white" style="position:fixed"></div>')
            // console.log(image) // 哪个图片在加载
          },
          onLazyImageReady: function (swiper, slide, image) {
            $(image).prev('img').remove()
            $(image).removeClass('hide')
            $(image).addClass('thispic')
          },
          onSlideChangeEnd: function (swiper) {
            $('.swiper-slide').not('.swiper-slide-active').children('.bigger-pic').removeClass('thispic')
          }
        })
        // console.log(mySwiper)
        $('.swiper-lazy-preloader-white').css('top', '50%')
      })
    },
    closeDialogStudents () { // 关闭选择学生弹出框
      this.isHideSelectStudent = true
    },
    selectedStudent (student) { // 显示某学生身高体重
      this.isHideSelectStudent = true
      this.studentId = student.studentId
      this.studentList = []
      this.studentList.push(this.studentId)
      this.scoreList = []
      this.sel_score_para.offset = 0
      this.selScore()
    },
    back () {
      if (this.studentId == 0) {
        this.$router.go(-1)
      } else {
        this.studentId = 0
        this.studentList = []
        this.scoreList = []
        this.sel_score_para.offset = 0
        delete this.sel_score_para.studentList
        this.selScore()
      }
    }
  },
  beforeDestroy: function () {
    if (this.mySwiper.destroy) {
      this.mySwiper.destroy(false, true)
    }

    // 保存缓存数据
    if (this.studentId == 0 && this.scoreList.length > 0) {
      let obj = {}
      obj.scrollTop = this.scrollTop
      if (this.scoreList.length > 50) {
        obj.scrollTop = 0
        this.sel_score_para.offset = 0
        this.scoreList.splice(50, this.scoreList.length - 50)
      }
      obj.scoreList = this.scoreList
      obj.sel_score_para = this.sel_score_para
      obj.isOver = this.isOver
      obj.refreshDate = this.localStorage_refreshDate || new Date().getTime()
      window.localStorage['scoreList'] = JSON.stringify(obj)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// scoreList.vue?56f1268d